import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import LabConnectionTableService from '../service/LabConnectionTableService';

const config = {
	key: 'labConnectionTable',
	topic: 'labConnection',
	service: LabConnectionTableService,
	editFormState: item => `/lab-connection/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['search', 'refresh', 'new'],
	rowAction: ['modify', 'delete'],
	columns: [
		{
			key: 'name'
		},
		{
			key: 'hostName'
		},
		{
			key: 'databaseName'
		},
		{
			key: 'user'
		}
	]
};

function LabConnectionTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('labConnectionTable', reducer('labConnectionTable'))(LabConnectionTable);
